import Api from "./api"

const DocumentPdfsService = {

  newDocumentPdf: async (params) => {
    const response = await Api.post("/documentPdfs/newDocumentPdf", params,
      {
        headers: {
          "auth-token": localStorage.getItem("auth-token"),
          "keep-logged": localStorage.getItem("keep-logged"),
        }
      }
    )
    localStorage.setItem("auth-token", response.headers["auth-token"])
    return response
  },
  
  editDocumentPdf: async (params) => {
    let response = await Api.put("/documentPdfs/editDocumentPdf", params,
    {
      headers: {
        "auth-token": localStorage.getItem("auth-token"),
        "keep-logged": localStorage.getItem("keep-logged"),
      }
    })
    localStorage.setItem("auth-token", response.headers["auth-token"])
    return response
  },

  getDocumentPdfById: async (params) => {
    let response = await Api.post("/attendances/getDocumentPdfById", params,
    {
      headers: {
      "auth-token": localStorage.getItem("auth-token"),
      "keep-logged": localStorage.getItem("keep-logged") 
      }
    })
    localStorage.setItem("auth-token", response.headers["auth-token"])
    return response
  },

  searchDocumentPdfs: async (params) => {
    let response = await Api.post("/documentPdfs/searchDocumentPdfs", params,
    {
      headers: {
        "auth-token": localStorage.getItem("auth-token"),
        "keep-logged": localStorage.getItem("keep-logged") 
      }
    })
    localStorage.setItem("auth-token", response.headers["auth-token"])
    return response
  },

  deleteDocumentPdf: async (params) => {
    let response = await Api.post("/documentPdfs/deleteDocumentPdf", params,
    {
      headers: {
        "auth-token": localStorage.getItem("auth-token"),
        "keep-logged": localStorage.getItem("keep-logged"),
      }
    })
    localStorage.setItem("auth-token", response.headers["auth-token"])
    return response
  },

}

export default DocumentPdfsService